import {useEffect, useState} from "react";
import {Sparkles, X, Mail} from "lucide-react";
import {apiGet, apiPut} from "@/lib/api";

export default function FestivalNudge({user, setUser, notify, setActive}) {
  const [data, setData] = useState(null);
  const tradition = user?.tradition || localStorage.getItem("io-tradition") || "Vaishnava";

  useEffect(() => {
    if (new Date().getHours() >= 12) return;
    apiGet("/festivals/today", {tradition}).then(d => {
      if (d.festivals?.length && localStorage.getItem("io-nudge-dismissed") !== d.date) setData(d);
    }).catch(() => {});
  }, [tradition]);

  if (!data) return null;
  const dismiss = () => { localStorage.setItem("io-nudge-dismissed", data.date); setData(null); };
  const enableEmail = async () => {
    try { const u = await apiPut("/users/me/preferences", {festival_emails: true}); setUser(u); notify("Festival morning emails are on"); }
    catch { notify("Please try again"); }
  };

  return (
    <div className="festival-nudge" data-testid="festival-nudge">
      <Sparkles size={18}/>
      <div>
        <small>GOOD MORNING · {data.tradition.toUpperCase()} TRADITION</small>
        <strong data-testid="festival-nudge-name">Today is {data.festivals.map(f => f.name).join(" · ")}</strong>
        <p>{data.festivals[0].note}</p>
      </div>
      <div className="festival-nudge-actions">
        <button data-testid="festival-nudge-panchang" className="outline-button sm" onClick={() => setActive("panchang")}>Panchang</button>
        {user && !user.festival_emails && (
          <button data-testid="festival-nudge-email" className="outline-button sm" onClick={enableEmail}><Mail size={12}/> Email me</button>
        )}
        <button data-testid="festival-nudge-dismiss" className="icon-button" onClick={dismiss}><X size={15}/></button>
      </div>
    </div>
  );
}
